import { render, staticRenderFns } from "./ChatNotificacion.vue?vue&type=template&id=7b3d9ed9&"
import script from "./ChatNotificacion.vue?vue&type=script&lang=js&"
export * from "./ChatNotificacion.vue?vue&type=script&lang=js&"
import style0 from "./ChatNotificacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports